import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { t } from 'shared'
import './copied_feedback_styles.sass'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CopiedFeedback = ({ copyMode, copyModeInstagram }: { copyMode: any; copyModeInstagram: any }) => {
  return (
    <>
      <CSSTransition in={copyMode} timeout={200} className="copy-overlay ui success message" unmountOnExit>
        <div>
          <strong>{t('misc.copied')}!</strong>
        </div>
      </CSSTransition>
      <CSSTransition
        in={copyModeInstagram}
        timeout={350}
        className="copy-overlay ui success message"
        unmountOnExit
        style={{ width: '100%', maxWidth: '75%' }}
      >
        <div>
          <strong>{t('misc.copied')}!</strong>
          <span>&nbsp;</span>
          <span>{t('misc.copy_link_instagram_hint')}</span>
        </div>
      </CSSTransition>
    </>
  )
}
